import httpClient from "@/api/httpClient";

const API_PREFIX = "v2/s3";

export default {
  getList(prefix) {
    return httpClient.get(`${API_PREFIX}/objects`,
                          {params: {prefix: prefix}});
  },
  upload(key, file, name, version) {
    let formData = new FormData();
    formData.append("file", file);
    return httpClient.post(`${API_PREFIX}/objects`,
                           formData,
                           {
                             params: {key: key},
                             headers: {
                               "Content-Type": "multipart/form-data",
                               "meta": JSON.stringify({name: encodeURIComponent(name), version: encodeURIComponent(version)})
                             }
                           });
  },
  getMetadata(key) {
    return httpClient.get(`${API_PREFIX}/meta-datas`,
                          {params: {key: key}});
  },
  delete(key) {
    return httpClient.delete(`${API_PREFIX}/objects`,
                             {
                               params: {key: key}
                             });
  },
  makeDirectory(path) {
    return httpClient.post(`${API_PREFIX}/directory`,
                           null,
                           {
                             params: {path: path}
                           });
  },
  deleteDirectory(path) {
    return httpClient.delete(`${API_PREFIX}/directory`,
                             {
                               params: {path: path}
                             });
  }
}
